
/* 
    属性copy,
    target:赋值的目标对象
    source:被拷贝的对象
    def:默认值
*/
export default function (target, source, def) {
    let keyArr = Object.keys(target);

    for (let i = 0; i < keyArr.length; i++) {
        let key = keyArr[i];
        if (source.hasOwnProperty(key)) {   //sourc有值
            target[key] = source[key];
        } else {
            if (def && def.hasOwnProperty(key)) {
                target[key] = def[key];
            };
        };
    }
}